import { createAsyncThunk } from '@reduxjs/toolkit';

import { setIsLoading } from '~/actions/paginatedTemplates';
import { getTemplates } from '~/api/templates';
import { FETCH_PAGINATED_TEMPLATES } from '~/actions/names';

export const fetchPaginatedTemplates = createAsyncThunk(
  FETCH_PAGINATED_TEMPLATES,
  async ({ enqueueSnackbar, requestType = null }, { getState, dispatch }) => {
    dispatch(setIsLoading(true));

    const state = getState();

    const {
      templatesPerPage,
      page,
      sort,
      order,
      search,
      type: savedType,
    } = state.paginatedTemplates;

    const type = requestType ?? savedType;

    try {
      const { templates, total } = await getTemplates({
        limit: templatesPerPage,
        offset: templatesPerPage * page,
        sort,
        order,
        type,
        search,
      });

      return {
        templates,
        total,
        templatesPerPage,
        page,
      };
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });

      throw error;
    }
  }
);
